module.exports = __webpack_public_path__ + "helpcontact-i7X.svg";